module.exports = __webpack_public_path__ + "img/theme-light.b990288b.png";